import { render, staticRenderFns } from "./UzivatelskeNotifikace.vue?vue&type=template&id=37b2adbe&scoped=true&"
import script from "./UzivatelskeNotifikace.vue?vue&type=script&lang=ts&"
export * from "./UzivatelskeNotifikace.vue?vue&type=script&lang=ts&"
import style0 from "./UzivatelskeNotifikace.vue?vue&type=style&index=0&id=37b2adbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b2adbe",
  null
  
)

export default component.exports